import { ReactNode } from "react";

interface LinkButtonProps {
  isLoading?: boolean;
  children: ReactNode;
  href?: string;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

export default function LinkButton ({
  children,
  href,
  onClick,
  isLoading,
  disabled = false,
  className = "",
}: LinkButtonProps) {
  const baseClasses =
    "secondary-button text-content-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-action-focus-border flex h-[52px] items-center justify-center gap-2 rounded-full px-6 text-sm font-medium leading-5 transition-shadow";

  const combinedClasses = `${baseClasses} ${className}`.trim();

  if (href) {
    return (
      <a href={href} className={combinedClasses}>
        {children}
      </a>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`${combinedClasses} cursor-pointer w-full ${isLoading ? 'btn loading' : ''}`}
    >
       {isLoading && (
        <div className="btn-loader">
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>
      )}
      {!isLoading && children}
    </button>
  );
};
